/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo } from "react";
import { ParentSize } from "@visx/responsive";
import {
  BrickLoader,
  UniversalWrap,
  StackBarChart,
  mapStackBarChartColors,
  ChartType,
  Granularity,
  EstatePeriod,
} from "~/components";
import { useEstateRecordsCostPerOrgUnit } from "./hooks";

type Props = {
  startDate: string;
  endDate: string;
  granularity: Granularity;
  period: EstatePeriod;
};

export function EstateRecordsCostPerOrgUnit({
  startDate,
  endDate,
  granularity,
  period,
}: Props) {
  const { costPerOrgUnitChartData, orgUnits } =
    useEstateRecordsCostPerOrgUnit(granularity);

  const stackBarColors = useMemo(
    () => mapStackBarChartColors(orgUnits),
    [orgUnits]
  );

  return (
    <UniversalWrap
      loaderProps={{ loading: false, Component: BrickLoader }}
      errorProps={{}}
    >
      <ParentSize>
        {(parent) => (
          <StackBarChart
            showOthers
            width={parent.width}
            height={280}
            data={costPerOrgUnitChartData}
            granularity={granularity}
            loading={false}
            startDate={startDate}
            endDate={endDate}
            period={period}
            colors={stackBarColors}
            chartType={ChartType.COST_PER_ORG_UNIT}
            keys={orgUnits}
          />
        )}
      </ParentSize>
    </UniversalWrap>
  );
}
